//输入控件
import React, { Component } from 'react';
import { DatePicker, List } from 'antd-mobile';
import { autobind } from 'core-decorators';
import tools from '../utils/tools'
import './DateControl.less'

class DateControl extends Component {

  //构造函数
  constructor(props, context) {
    //写构造方法时  必须实现父类的构造方法  否则构造失败  报错
    super(props, context);
  }
  /*================自定义事件====================*/

  formatDate = (value) =>{
    // console.log(value.toString())
    const { templateItem } = this.props;
    return templateItem && templateItem.Format ? tools.dateFormat(value,templateItem.Format) : tools.formatDate(value);
  }

  render() {
    const { Name, value ,ReadOnly,templateItem} = this.props;
    let dateValue = value;
    dateValue = typeof dateValue == 'string' && dateValue != '' ? new Date(dateValue.replace(/\-/g, "/")) : dateValue;
    dateValue = dateValue instanceof Date && this.formatDate(dateValue) == "" ? "" : dateValue;
    const className = dateValue == '' ? 'icon-rili':'icon-shanchu1';
    const controlClassName =  dateValue == '' ? 'dateControl':'dateControl_selected';
    if(ReadOnly){
      return ( <p data-Name={Name}>{this.formatDate(dateValue)}</p>)
    }
    return (<div className={controlClassName}><DatePicker
      data-Name={Name}
      mode= {templateItem && templateItem.Format && templateItem.Format.indexOf('HH:mm')>=0 ? "datetime": "date"}
      value={dateValue}
      onChange={this.onChange}
      minDate= {new Date('1950/01/01')}
      maxDate= {new Date('2080/12/31')}>
      <List.Item></List.Item>
    </DatePicker> {dateValue && <span onClick={this.clear} className={`icon iconfont ${className} dateIcon`}/>}</div>);
  }

  @autobind
  onChange(date) {
    const { onChange } = this.props;
    if (onChange)
      onChange(new Date(this.formatDate(date)));
  }

  clear = ()=>{
    const { onChange } = this.props;
    if (onChange)
      onChange(new Date('0001-01-01'));
  }
}
export default DateControl;
